/**
 * Seekers Bookings Routes
 *
 * This route serves shows interview requests, (EONC) bookings, and completed contracts for seekers/parents
 *
 *
 * Guards:
 * - requireSeeker: Ensures user is a parent (authentication)
 * - checkCorporateOnboarding: Ensures corporate parents have completed onboarding
 */
import { RouteRecordRaw } from 'vue-router';
import { requireSeeker } from '@/router/guards/authGuards';
import { checkCorporateOnboarding } from '@/router/guards/completionGuards';
import combineGuards from '../guards/helpers';

const bookingsRoutes: RouteRecordRaw[] = [
  {
    path: '/bookings',
    name: 'seeker-bookings',
    component: () => import('@/apps/bookings/SeekerBookings.vue'),
    beforeEnter: combineGuards([requireSeeker, checkCorporateOnboarding]),
  },
  {
    path: '/bookings/booking/confirmed/:contractId',
    name: 'seeker-booking-confirmed',
    component: () => import('@/apps/bookings/booking/confirmed/SeekerBookingConfirmed.vue'),
    props: (route) => ({ contractId: route.params.contractId }),
    beforeEnter: requireSeeker,
  },
  {
    path: '/bookings/booking/accepted/:contractId',
    name: 'seeker-booking-accepted',
    component: () => import('@/apps/bookings/booking/accepted/SeekerBookingAccepted.vue'),
    props: (route) => ({ contractId: route.params.contractId }),
    beforeEnter: requireSeeker,
  },
  {
    path: '/bookings/interview/accepted/:contractId',
    name: 'seeker-interview-accepted',
    component: () => import('@/apps/bookings/interview/accepted/SeekerInterviewAccepted.vue'),
    props: (route) => ({ contractId: route.params.contractId }),
    beforeEnter: requireSeeker,
  },
  {
    path: '/bookings/interview/pending/:interviewId',
    name: 'seeker-interview-pending',
    component: () => import('@/apps/bookings/interview/pending/SeekerInterviewPending.vue'),
    props: (route) => ({ interviewId: route.params.interviewId }),
    beforeEnter: requireSeeker,
  },
  {
    path: '/bookings/booking/pending/:bookingId',
    name: 'seeker-booking-pending',
    component: () => import('@/apps/bookings/booking/pending/SeekerBookingPending.vue'),
    props: (route) => ({ bookingId: route.params.bookingId }),
    beforeEnter: requireSeeker,
  },
];

export default bookingsRoutes;
